import { DetailedHTMLProps, forwardRef, HTMLAttributes } from 'react';

import { classNames } from '@/utils';

import { TIKTOK_BUSINESS, X } from '@/lib/socialProfile';

export type IconProps = DetailedHTMLProps<HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> & {
    className?: string;
    icon: string;
};

const Icon = forwardRef<HTMLSpanElement, IconProps>(
    ({ icon, className = '', ...restProps }, ref) => {
        let displayedIcon = icon;

        if (icon === TIKTOK_BUSINESS) {
            displayedIcon = 'tiktok';
        } else if (icon === X) {
            displayedIcon = 'twitter';
        }

        return (
            <i
                ref={ref}
                className={classNames(`icon-${displayedIcon}`, className)}
                {...restProps}
            />
        );
    }
);

Icon.displayName = 'Icon';

export default Icon;
